'use client'

import type { ComponentProps } from 'react'

import { default as NextImage } from 'next/image'

import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { FeatureFlags, type FlagValues } from '@/helpers/featureFlags'

type Props = Omit<ComponentProps<typeof NextImage>, 'loader'> & {
  ref?: React.Ref<HTMLImageElement>
}

const loaders: Record<
  FlagValues<typeof FeatureFlags.IMAGE_OPTIMIZATION_STRATEGY>,
  ComponentProps<typeof NextImage>['loader']
> = {
  'next-image-optimization': undefined,
  none: ({ src }) => src,
  'third-party': ({ src }) => src, // NOTE: Not implemented
}

export function useImageLoader() {
  const optimizationStrategy = useFlag(FeatureFlags.IMAGE_OPTIMIZATION_STRATEGY)
  return loaders[optimizationStrategy]
}

function Image({ ref, ...props }: Props) {
  const loader = useImageLoader()

  return <NextImage {...props} ref={ref} loader={loader} />
}

export default Image
